import { Box, Stack, Theme, Typography } from "@mui/material";
import React, { ReactNode } from "react";

interface BreadCrumbType {
  children: ReactNode;
  action?: ReactNode;
  subTitle?: ReactNode;
}

const Breadcrumb = ({ children, action, subTitle }: BreadCrumbType) => {
  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        borderRadius: (theme: Theme) => theme.shape.borderRadius / 4,
        p: "30px 25px 20px",
        marginBottom: "30px",
        marginTop: "20px",
        position: "relative",
        overflow: "hidden"
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <div>
          <Typography variant="h3">{children}</Typography>
          {subTitle && subTitle}
        </div>
        {action && action}
      </Stack>
    </Box>
  );
};

export default Breadcrumb;
